import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import ColorModeContext from "../../layout/themeContext";
import defaultLogoLight from "../../assets/logo.png";
import defaultLogoDark from "../../assets/logo-black.png";

const Logo = ({ className = "", linkTo = "/", size = "medium" }) => {
  const { colorMode } = useContext(ColorModeContext);
  const [imgError, setImgError] = useState(false);

  const getLogo = () => {
    // Se o tema tiver métodos calculados, usa eles
    if (colorMode?.calculatedLogoLight && colorMode?.calculatedLogoDark) {
      if (colorMode?.mode === "light") {
        return imgError
          ? defaultLogoLight
          : colorMode.calculatedLogoLight() || defaultLogoLight;
      } else {
        return imgError
          ? defaultLogoDark
          : colorMode.calculatedLogoDark() || defaultLogoDark;
      }
    }
    
    // Fallback para logos do contexto
    if (colorMode?.mode === "light") {
      return imgError
        ? defaultLogoLight
        : colorMode?.appLogoLight || defaultLogoLight;
    } else {
      return imgError 
        ? defaultLogoDark 
        : colorMode?.appLogoDark || defaultLogoDark;
    }
  };

  const sizeMap = {
    small: { height: "24px", maxWidth: "120px" },
    medium: { height: "32px", maxWidth: "160px" },
    large: { height: "40px", maxWidth: "200px" },
  };

  const handleError = () => {
    console.log("Erro ao carregar logo, usando fallback");
    setImgError(true);
  };

  const TextLogo = () => (
    <div
      className="text-logo"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: sizeMap[size].height,
        minWidth: "80px",
        maxWidth: sizeMap[size].maxWidth,
        backgroundColor: colorMode?.primaryColorLight || "#1E3A8A",
        color: "white",
        fontWeight: "bold",
        borderRadius: "5px",
        padding: "0 12px",
        fontSize:
          size === "small" ? "12px" : size === "medium" ? "14px" : "16px",
      }}
    >
      {colorMode?.appName || "Sistema"}
    </div>
  );

  const logoUrl = getLogo();

  return (
    <Link to={linkTo} className={`logo-link ${className}`} style={{ textDecoration: "none" }}>
      {logoUrl ? (
        <img
          src={logoUrl}
          alt={colorMode?.appName || "Logo"}
          className="logo-img"
          style={{
            height: sizeMap[size].height,
            maxWidth: sizeMap[size].maxWidth,
            objectFit: "contain",
          }}
          onError={handleError}
        />
      ) : (
        <TextLogo />
      )}
    </Link>
  );
};

export default Logo;
